import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { MatDrawer, MatDialog } from '@angular/material';
import { ViewChild } from '@angular/core';
import {EulaComponent} from '../eula/eula.component';
import {AngularFirestore} from 'angularfire2/firestore';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer') drawer: MatDrawer;
  constructor(private afs: AngularFirestore, public fauth: AngularFireAuth, public router: Router, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.fauth.authState.subscribe(res => {
      this.afs.collection('profiles').doc(this.fauth.auth.currentUser.uid).ref.get().then(doc => {
      if (!doc.exists || !doc.get('eula')) {
        this.showEulaDialog();
      }
    })
    .catch(e => {
      console.log(e);
    });
  });
  }

  ngAfterViewInit() {
  }

  openPajakKeluaran() {
    // this.router.navigateByUrl('/app/fk');
    // this.toggleDrawer();
    this.router.navigateByUrl('/app/fk');
    this.toggleDrawer();
  }

  showEulaDialog() {
    const ref = this.dialog.open(EulaComponent, {disableClose: true});
  }

  toggleDrawer() {
    this.drawer.toggle();
  }

  openPajakMasukan() {
    this.router.navigateByUrl('/app/fm');
    this.toggleDrawer();
  }

  openFaqComponent() {
    this.router.navigateByUrl('/app/faq');
  }

  openPrivacyStatement() {
    this.router.navigateByUrl('/app/privacy');
    this.toggleDrawer();
  }

  openAboutComponent() {
    this.router.navigateByUrl('/app/about');
    this.toggleDrawer();
  }

  openEulaComponent() {
    this.router.navigateByUrl('/app/eula');
    this.toggleDrawer();
  }

  openMobileScannerComponent() {
    this.router.navigateByUrl('/app/mobile_scanner');
    this.toggleDrawer();
  }

  signout() {
    this.fauth.auth.signOut()
    .then(res => {
      console.log(res);
    })
    .catch(err => {
    });
  }

  openEula() {

  }

}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts